import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./LeftSection.css";

// Import your images - adjust paths based on your actual folder structure
// Copy these import paths from your Home.js file
import search from "../../../assets/home-images/search.png";
import videos from "../../../assets/home-images/videos.png";
import downarrow from "../../../assets/home-images/downarrow.png";
import flagicon from "../../../assets/home-images/flagicon.png";
import xmark from "../../../assets/home-images/right-section-images/xmark.png";

// Country flags
import canadaflag from '../../../assets/experience/canadaflag.png';

import omanflag from "../../../assets/experience/omanflag.png";
import qatarflag from "../../../assets/experience/qatarflag.png";
import kuwaitflag from "../../../assets/experience/kuwaitflag.png";
import ksaflag from "../../../assets/experience/ksaflag.png";
import axios from "axios";
import useEmirateFromCoordinates, { BACKEND_URL } from "../../common/Common";

// Uncomment these if you need them in the future
// import blogs from "../../assets/images/blogs.png";
// import save from "../../assets/images/save.png";
// import profileicon from "../../assets/images/profileicon.png";
// import plusicon from "../../assets/images/plusicon.png";
// import menu from "../../assets/images/menu.png";

//rightsection images
import hayatlogo from '../../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../../assets/home-images/right-section-images/qr.png';
import app_store from '../../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../../assets/home-images/right-section-images/play_store.png';
// import xmark from '../../assets/home-images/right-section-images/xmark.png';
// import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';

const countryicons = [canadaflag, omanflag, qatarflag, kuwaitflag, ksaflag];

const LeftSection = ({
    selectedState = null,
    onStateChange = null,
    states = [],
    showLocationSelector = false,
    initialSearchValue = "",
    hideVideos = false
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [countrypopup, setCountrypopup] = useState(false);
    // const [savehomesearchtext, setSavehomesearchtext] = useState([]);
    const [searchText, setSearchText] = useState(initialSearchValue || "");
    // const [gethomesearchtext, setGethomesearchtext] = useState([]);
    const [vendorlist, setVendorlist] = useState([]);
    const [allVendors, setAllVendors] = useState([]); // Store all vendors for client-side filtering
    const [showDropdown, setShowDropdown] = useState(false);
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const debounceTimerRef = useRef(null);
    const searchBoxRef = useRef(null);
    const dropdownRef = useRef(null);
    const [searchpostlist, setSearchpostlist] = useState([]);
    const [searchCoupons, setSearchCoupons] = useState([]); // Coupons from search-post-list API
    const [searchEvents, setSearchEvents] = useState([]); // Events from get-event-list API
    const [allEvents, setAllEvents] = useState([]); // Store all events for client-side filtering
    const [hasNoVendorMatch, setHasNoVendorMatch] = useState(false);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const emirate = useEmirateFromCoordinates(latitude, longitude);

    // Helper function to get flag icon based on selected state
    const getFlagIcon = (state) => {
        if (!state) return flagicon;

        // Toronto (id === 9) uses Canada flag
        if (state.id === 9) return countryicons[0]; // Canada
        // Abu Dhabi (id === 1) and Dubai (id === 2) use default flagicon
        if (state.id === 1 || state.id === 2) return flagicon;
        // Oman (id === 5)
        if (state.id === 5) return countryicons[1]; // Oman
        // Qatar (id === 6)
        if (state.id === 6) return countryicons[2]; // Qatar
        // Kuwait (id === 7)
        if (state.id === 7) return countryicons[3]; // Kuwait
        // KSA (id === 8)
        if (state.id === 8) return countryicons[4]; // KSA

        // Default to flagicon for any other state
        return flagicon;
    };

    const handleStateClick = (state) => {
        if (onStateChange) {
            onStateChange(state);
        }
        setCountrypopup(false);
    };

    // Handler to set flag when navigating from left section
    const handleLeftSectionNavigation = () => {
        sessionStorage.setItem('navigatedFromNavbarOrLeftSection', 'true');
    };

    // const fetchsavehomesearchtext = async (searchValue = "") => {
    //     const payload = {
    //         login_user_id: 501,
    //         search_text: searchValue
    //     }
    //     try {
    //         const response = await axios.post(`${BACKEND_URL}website/save-homesearch-text`, payload);
    //         setSavehomesearchtext(response.data)
    //         console.log(response.data);

    //     } catch (error) {
    //         console.error("Error fetching  data:", error);

    //     }
    // }

    // const handleSearchChange = (e) => {
    //     const value = e.target.value;
    //     setSearchText(value);
    // };

    // const handleSearchSubmit = (e) => {
    //     if (e.key === "Enter" || e.type === "click") {
    //         fetchsavehomesearchtext(searchText);
    //     }
    // };

    // const fetchgethomesearchtext = async () => {
    //     const payload = {
    //         login_user_id: 501,
    //         latitude: 24.517725,
    //         longitude: 54.363599,
    //     }
    //     try {
    //         const response = await axios.post(`${BACKEND_URL}website/get-homesearch-text`, payload);
    //         setGethomesearchtext(response.data)
    //         console.log(response.data);
    //     } catch (error) {
    //         console.error("Error fetching get home search text data:", error);

    //     }
    // }

    // useEffect(() => {
    //     fetchsavehomesearchtext();
    //     fetchgethomesearchtext();
    // }, [])

    const fetchvendorlist = async (searchValue = "") => {
        const payload = {
            login_user_id: 501,
            search_text: searchValue || ""
        }
        setIsLoading(true);
        try {
            const response = await axios.post(`${BACKEND_URL}website/get-vendor-list`, payload);
            // Handle different response structures
            const data = response.data?.data || response.data || [];
            const vendorsArray = Array.isArray(data) ? data : [];

            // Always store all vendors (for client-side filtering)
            // If this is initial load or we got more vendors than we have stored, update allVendors
            if (vendorsArray.length > allVendors.length || allVendors.length === 0) {
                setAllVendors(vendorsArray);
            }

            // Always filter vendors based on search text (client-side filtering)
            // This ensures filtering works even if backend doesn't filter
            const filteredVendors = filterVendorsBySearch(vendorsArray, searchValue);
            setVendorlist(filteredVendors);

            // Always fetch coupons and events from search-post-list when searching
            if (searchValue && searchValue.trim().length > 0) {
                if (filteredVendors.length === 0) {
                    setHasNoVendorMatch(true);
                } else {
                    setHasNoVendorMatch(false);
                }
                fetchsearchpostlist(searchValue);
                fetcheventlist(searchValue);
            } else {
                setHasNoVendorMatch(false);
                setSearchCoupons([]);
                setSearchEvents([]);
            }
            // console.log("Search:", searchValue, "Total vendors:", vendorsArray.length, "Filtered:", filteredVendors.length);
        } catch (error) {
            console.error("Error fetching vendor data:", error);
            setVendorlist([]);
            // If search has value but error occurred, still try fetching coupons
            if (searchValue && searchValue.trim().length > 0) {
                setHasNoVendorMatch(true);
                fetchsearchpostlist(searchValue);
            }
        } finally {
            setIsLoading(false);
        }
    }

    // Helper function to get search position score (lower score = higher priority)
    const getSearchPositionScore = (text, searchTerm) => {
        if (!text || !searchTerm) return Infinity;
        const textLower = text.toLowerCase();
        const searchLower = searchTerm.toLowerCase().trim();
        const position = textLower.indexOf(searchLower);

        if (position === -1) return Infinity; // Not found

        // Lower position = higher priority
        // Position 0 (starts with) = highest priority
        return position;
    };

    // Client-side filtering function
    const filterVendorsBySearch = (vendors, searchValue) => {
        if (!searchValue || searchValue.trim() === "") {
            return vendors;
        }

        const searchLower = searchValue.toLowerCase().trim();
        const filtered = vendors.filter((vendor) => {
            const vendorName = (vendor.vendor_name || vendor.user_name || vendor.name || "").toLowerCase();
            const businessType = (vendor.type_of_business || vendor.business_type || "").toLowerCase();
            const city = (vendor.city || "").toLowerCase();

            // Search in vendor name, business type, or city
            return (
                vendorName.includes(searchLower) ||
                businessType.includes(searchLower) ||
                city.includes(searchLower)
            );
        });

        // Sort by search term position (earlier position = higher priority)
        return filtered.sort((a, b) => {
            const aName = (a.vendor_name || a.user_name || a.name || "").toLowerCase();
            const bName = (b.vendor_name || b.user_name || b.name || "").toLowerCase();
            const aBusinessType = (a.type_of_business || a.business_type || "").toLowerCase();
            const bBusinessType = (b.type_of_business || b.business_type || "").toLowerCase();
            const aCity = (a.city || "").toLowerCase();
            const bCity = (b.city || "").toLowerCase();

            // Get the best (lowest) position score for each vendor
            const aScore = Math.min(
                getSearchPositionScore(aName, searchLower),
                getSearchPositionScore(aBusinessType, searchLower),
                getSearchPositionScore(aCity, searchLower)
            );
            const bScore = Math.min(
                getSearchPositionScore(bName, searchLower),
                getSearchPositionScore(bBusinessType, searchLower),
                getSearchPositionScore(bCity, searchLower)
            );

            return aScore - bScore; // Lower score comes first
        });
    }

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchText(value);

        // Show list when user starts typing
        if (value.trim().length > 0) {
            setShowDropdown(true);
        } else {
            setShowDropdown(false);
            // If search is cleared, show all vendors
            if (allVendors.length > 0) {
                setVendorlist(allVendors);
            }
            setHasNoVendorMatch(false);
        }

        // Immediate client-side filtering for better UX (instant results)
        if (allVendors.length > 0) {
            const filtered = filterVendorsBySearch(allVendors, value);
            setVendorlist(filtered);
            // Check if no vendors match after client-side filtering
            if (value.trim().length > 0 && filtered.length === 0) {
                setHasNoVendorMatch(true);
            } else {
                setHasNoVendorMatch(false);
            }
        }

        // Immediate client-side filtering for events
        if (allEvents.length > 0 && value.trim().length > 0) {
            const searchLower = value.toLowerCase().trim();
            const filteredEvents = allEvents.filter((event) => {
                const eventTitle = String(event.title || "").toLowerCase().trim();
                return eventTitle.includes(searchLower);
            });

            const sortedEvents = filteredEvents.sort((a, b) => {
                const aTitle = (a.title || "").toLowerCase();
                const bTitle = (b.title || "").toLowerCase();
                const aScore = getSearchPositionScore(aTitle, searchLower);
                const bScore = getSearchPositionScore(bTitle, searchLower);
                return aScore - bScore;
            });

            setSearchEvents(sortedEvents);
        } else if (value.trim().length === 0) {
            setSearchEvents([]);
        }

        // Clear existing timer
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        // Set new timer for debounced API call (to get updated data from server)
        debounceTimerRef.current = setTimeout(() => {
            fetchvendorlist(value);
        }, 300); // 300ms delay - adjust as needed
    };

    const handleSearchEnter = (e) => {
        if (e.key === "Enter" && searchText.trim().length > 0) {
            // Navigate to search page with search query
            navigate(`/searchpage?search=${encodeURIComponent(searchText.trim())}`);
        }
    };

    const handleVendorSelect = (vendor) => {
        setSearchText(vendor.vendor_name || vendor.user_name || vendor.name || "");
        setShowDropdown(false);
    };

    const handleClearSearch = () => {
        setSearchText("");
        setShowDropdown(false);
        setHasNoVendorMatch(false);
        setSearchpostlist([]);
        setSearchCoupons([]);
        setSearchEvents([]);
        // Clear the vendor list or reset to all vendors
        if (allVendors.length > 0) {
            setVendorlist(allVendors);
        } else {
            fetchvendorlist("");
        }
    };

    // Close list when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                searchBoxRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !searchBoxRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }
        };

        if (showDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDropdown]);

    // Update search text when initialSearchValue prop changes
    useEffect(() => {
        if (initialSearchValue !== undefined && initialSearchValue !== searchText) {
            setSearchText(initialSearchValue);
            if (initialSearchValue && initialSearchValue.trim().length > 0) {
                setShowDropdown(true);
                fetchvendorlist(initialSearchValue);
            } else {
                setShowDropdown(false);
            }
        }
    }, [initialSearchValue]);

    // Set default location and try to get user's geolocation (same pattern as Home.js and Events.js)
    useEffect(() => {
        // Set default location immediately to avoid waiting for geolocation
        setLatitude(24.4539);
        setLongitude(54.3773);

        // Try to get user's actual location (non-blocking)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    // Keep default values already set above
                },
                {
                    timeout: 5000, // 5 second timeout
                    enableHighAccuracy: false // Faster response
                }
            );
        }
    }, []);

    // Update coordinates when selectedState changes (if state has coordinates)
    useEffect(() => {
        if (selectedState) {
            const lat = parseFloat(selectedState.latitude || selectedState.lat || 24.4539);
            const lng = parseFloat(selectedState.longitude || selectedState.lng || 54.3773);
            setLatitude(lat);
            setLongitude(lng);
        }
    }, [selectedState]);

    // Initial fetch on component mount
    useEffect(() => {
        if (searchText && searchText.trim().length > 0) {
            fetchvendorlist(searchText);
        } else {
            fetchvendorlist();
        }
        // Cleanup timer on unmount
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);

    // Fetch all events when coordinates are available (same pattern as Events.js)
    useEffect(() => {
        if (latitude !== null && longitude !== null) {
            fetcheventlist("");
        }
    }, [latitude, longitude, selectedState, emirate]);


    const fetchsearchpostlist = async (searchValue = "") => {
        if (!searchValue || searchValue.trim().length === 0) {
            setSearchCoupons([]);
            setSearchpostlist([]);
            return;
        }

        // IMPORTANT: Backend API only searches by user_name, not coupon_title
        // So we call API WITHOUT search term to get ALL coupons, then filter client-side
        const payload = {
            login_user_id: 501,
            latitude: 24.517725,
            longitude: 54.363599,
            search: "", // Empty search to get all coupons - we'll filter client-side
        }
        try {
            const response = await axios.post(`${BACKEND_URL}website/search-post-list`, payload);
            const data = response?.data || {};
            setSearchpostlist(data);

            // Extract coupon_list from response
            let coupons = [];

            if (Array.isArray(data)) {
                // If it's an array, filter for coupons
                coupons = data.filter(item => item.coupon_id || item.coupon_title || item.discount_type_id);
            } else {
                // Handle object response
                if (data.coupon_list) {
                    coupons = Array.isArray(data.coupon_list) ? data.coupon_list : [];
                } else if (data.offers) {
                    coupons = Array.isArray(data.offers) ? data.offers : [];
                } else if (data.coupons) {
                    coupons = Array.isArray(data.coupons) ? data.coupons : [];
                }
            }

            // CLIENT-SIDE FILTERING: Filter coupons based on BOTH coupon_title AND user_name
            // This allows searching by coupon_title (which backend doesn't support)
            const searchLower = searchValue.toLowerCase().trim();
            const filteredCoupons = coupons.filter((coupon) => {
                const couponTitle = String(coupon.coupon_title || "").toLowerCase().trim();
                const userName = String(coupon.user_name || "").toLowerCase().trim();

                // Check if search term appears in coupon_title OR user_name (letter-by-letter matching)
                // This allows matching "buy" in "Buy 1 Get 1 Free" or "bu" in user names
                const titleMatch = couponTitle.includes(searchLower);
                const nameMatch = userName.includes(searchLower);

                return titleMatch || nameMatch;
            });

            // Sort coupons by search term position in coupon_title (earlier position = higher priority)
            // Prioritize coupon_title over user_name for sorting
            const sortedCoupons = filteredCoupons.sort((a, b) => {
                const aTitle = (a.coupon_title || "").toLowerCase();
                const bTitle = (b.coupon_title || "").toLowerCase();
                const aName = (a.user_name || "").toLowerCase();
                const bName = (b.user_name || "").toLowerCase();

                // Get position score for coupon_title (primary) and user_name (fallback)
                const aTitleScore = getSearchPositionScore(aTitle, searchLower);
                const bTitleScore = getSearchPositionScore(bTitle, searchLower);
                const aNameScore = getSearchPositionScore(aName, searchLower);
                const bNameScore = getSearchPositionScore(bName, searchLower);

                // Prioritize coupon_title: if both have title match, compare by title position
                // If one has title match and other doesn't, title match wins
                // If neither has title match, compare by user_name
                const aScore = aTitleScore !== Infinity ? aTitleScore : (aNameScore !== Infinity ? aNameScore + 1000 : Infinity);
                const bScore = bTitleScore !== Infinity ? bTitleScore : (bNameScore !== Infinity ? bNameScore + 1000 : Infinity);

                return aScore - bScore; // Lower score comes first
            });

            setSearchCoupons(sortedCoupons);
        } catch (error) {
            console.error("Error fetching search post data:", error);
            setSearchpostlist([]);
            setSearchCoupons([]);
        }
    }

    // Fetch events from get-event-list API (same payload structure as Events.js)
    const fetcheventlist = async (searchValue = "") => {
        // Only proceed if we have coordinates (same pattern as Events.js)
        if (latitude === null || longitude === null) {
            // Set default coordinates if not available
            const defaultLat = 24.4539;
            const defaultLng = 54.3773;
            setLatitude(defaultLat);
            setLongitude(defaultLng);
            // Return early, will retry after coordinates are set
            return;
        }

        // IMPORTANT: Backend API may not search by title, so we call API to get ALL events, then filter client-side
        // Use same payload structure as Events.js
        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            state_id: selectedState?.id || emirate?.id || "",
            user_id: "",
        };

        try {
            const response = await axios.post(`${BACKEND_URL}website/get-event-list`, payload);
            const data = response?.data || [];
            const eventsArray = Array.isArray(data) ? data : [];

            // Always store all events (for client-side filtering)
            if (eventsArray.length > allEvents.length || allEvents.length === 0) {
                setAllEvents(eventsArray);
            }

            // If no search value, clear search events
            if (!searchValue || searchValue.trim().length === 0) {
                setSearchEvents([]);
                return;
            }

            // CLIENT-SIDE FILTERING: Filter events based on title
            const searchLower = searchValue.toLowerCase().trim();
            const filteredEvents = eventsArray.filter((event) => {
                const eventTitle = String(event.title || "").toLowerCase().trim();
                return eventTitle.includes(searchLower);
            });

            // Sort events by search term position in title (earlier position = higher priority)
            const sortedEvents = filteredEvents.sort((a, b) => {
                const aTitle = (a.title || "").toLowerCase();
                const bTitle = (b.title || "").toLowerCase();

                const aScore = getSearchPositionScore(aTitle, searchLower);
                const bScore = getSearchPositionScore(bTitle, searchLower);

                return aScore - bScore; // Lower score comes first
            });

            setSearchEvents(sortedEvents);
        } catch (error) {
            console.error("Error fetching event list:", error);
            setSearchEvents([]);
        }
    }

    // Check if there's any content below search box to show
    const hasContentBelowSearch = !showDropdown && (
        (!hideVideos && (location.pathname === "/" || location.pathname.startsWith("/videoposts"))) ||
        showLocationSelector
    );

    return (
        <>
            <aside className={`left-section ${isSearchFocused || showDropdown ? 'search-active' : ''}`}>
                <div className="searchbox-wrapper">
                    <div className="searchbox" ref={searchBoxRef}>
                        <img src={search} alt="search" style={{ cursor: "pointer" }} />
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchText}
                            onChange={handleSearchChange}
                            onKeyDown={handleSearchEnter}
                            onFocus={() => {
                                setIsSearchFocused(true);
                                if (searchText.trim().length > 0 && (vendorlist.length > 0 || searchCoupons.length > 0 || searchEvents.length > 0)) {
                                    setShowDropdown(true);
                                }
                            }}
                            onBlur={() => {
                                // Delay to allow click events on dropdown items
                                setTimeout(() => {
                                    setIsSearchFocused(false);
                                }, 200);
                            }}
                        />
                        {searchText && searchText.trim().length > 0 && (
                            <img
                                src={xmark}
                                alt="clear"
                                className="search-clear-icon"
                                onClick={handleClearSearch}
                                style={{ cursor: "pointer", display: "block" }}
                            />
                        )}
                    </div>
                </div>

                {/* Show search results (vendors and coupons) below search when searching */}
                {showDropdown && searchText.trim().length > 0 && (
                    <div className="vendor-list-container" ref={dropdownRef}>
                        {isLoading ? (
                            <div className="vendor-list-loading">Loading...</div>
                        ) : (
                            <>
                                {/* Display Vendors from get-vendor-list API */}
                                {vendorlist.length > 0 && vendorlist.map((vendor, index) => {
                                    const vendorId = vendor.user_id || vendor.vendor_id || vendor.id;
                                    const vendorName = vendor.vendor_name || vendor.user_name || vendor.name || "Unknown Vendor";
                                    const vendorImage = vendor.user_image || vendor.vendor_cover_image || vendor.profile_image || "";
                                    const userType = String(vendor.user_type || vendor.userType || "");
                                    const isUserTypeZero = userType === "0";

                                    return (
                                        <div
                                            key={vendorId || index}
                                            className="vendor-list-item"
                                            onClick={() => {
                                                handleVendorSelect(vendor);
                                                navigate(`/searchpage/${vendorId}`);
                                            }}
                                        >
                                            <div className="vendor-list-content">
                                                {vendorImage && vendorImage.trim() !== '' ? (
                                                    <img
                                                        src={vendorImage}
                                                        alt={vendorName}
                                                        className={`vendor-list-image ${isUserTypeZero ? 'vendor-list-image-circle' : 'vendor-list-image-square'}`}
                                                    />
                                                ) : (
                                                    <div className={`vendor-list-initial ${isUserTypeZero ? 'vendor-list-initial-circle' : 'vendor-list-initial-square'}`}>
                                                        {vendorName ? vendorName.charAt(0).toUpperCase() : '?'}
                                                    </div>
                                                )}
                                                <span className="vendor-list-name">{vendorName}</span>
                                            </div>
                                            <Link
                                                to={isUserTypeZero ? `/userprofile/${vendorId}` : `/vendordetails/${vendorId}`}
                                                className="vendor-view-profile-btn remove-underline"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleVendorSelect(vendor);
                                                }}
                                            >
                                                View Profile
                                            </Link>
                                        </div>
                                    );
                                })}

                                {/* Display Coupons (Offers) from search-post-list API */}
                                {searchCoupons.length > 0 && searchCoupons.map((coupon, index) => {
                                    const couponId = coupon.coupon_id;
                                    const userId = coupon.user_id;
                                    const userName = coupon.coupon_title || "Unknown offer name";
                                    const userImage = coupon.coupon_image || "";
                                    const categoryId = coupon.category?.[0]?.category || 0;

                                    return (
                                        <div
                                            key={`coupon-${couponId || index}`}
                                            className="vendor-list-item"
                                            onClick={() => {
                                                navigate(`/offers/${couponId}/${categoryId}`);
                                                setShowDropdown(false);
                                                setSearchText("");
                                            }}
                                        >
                                            <div className="vendor-list-content">
                                                {userImage && userImage.trim() !== '' ? (
                                                    <img
                                                        src={userImage}
                                                        alt={userName}
                                                        className="vendor-list-image vendor-list-image-square"
                                                    />
                                                ) : (
                                                    <div className="vendor-list-initial vendor-list-initial-square">
                                                        {userName ? userName.charAt(0).toUpperCase() : '?'}
                                                    </div>
                                                )}
                                                <span className="vendor-list-name">{userName}</span>
                                            </div>
                                            <span className="vendor-offer-text">Offer</span>
                                        </div>
                                    );
                                })}

                                {/* Display Events from get-event-list API */}
                                {searchEvents.length > 0 && searchEvents.map((event, index) => {
                                    const eventId = event.event_id;
                                    const eventTitle = event.title || "Unknown event";
                                    const eventImage = event.event_image || "";

                                    return (
                                        <div
                                            key={`event-${eventId || index}`}
                                            className="vendor-list-item"
                                            onClick={() => {
                                                navigate(`/eventdetails/${eventId}`);
                                                setShowDropdown(false);
                                                setSearchText("");
                                            }}
                                        >
                                            <div className="vendor-list-content">
                                                {eventImage && eventImage.trim() !== '' ? (
                                                    <img
                                                        src={eventImage}
                                                        alt={eventTitle}
                                                        className="vendor-list-image vendor-list-image-square"
                                                    />
                                                ) : (
                                                    <div className="vendor-list-initial vendor-list-initial-square">
                                                        {eventTitle ? eventTitle.charAt(0).toUpperCase() : '?'}
                                                    </div>
                                                )}
                                                <span className="vendor-list-name">{eventTitle}</span>
                                            </div>
                                            <span className="vendor-offer-text">Event</span>
                                        </div>
                                    );
                                })}

                                {/* No results message */}
                                {vendorlist.length === 0 && searchCoupons.length === 0 && searchEvents.length === 0 && !isLoading && (
                                    <div className="vendor-list-loading">No results found</div>
                                )}
                            </>
                        )}
                    </div>
                )}

                {/* Hide "Videos for you" section when searching */}
                {!showDropdown && (
                    <div className="left-menu-content">
                        {!hideVideos && (location.pathname === "/" || location.pathname.startsWith("/videoposts")) && (
                            <Link
                                to="/videoposts"
                                className="remove-underline"
                                onClick={() => {
                                    sessionStorage.setItem('videopost_navigated', 'true');
                                    sessionStorage.setItem('fetch_all_videos', 'true');
                                }}
                            >
                                <div className="img-contentname">
                                    <img src={videos} alt="videos" />
                                    <p>Videos for you</p>
                                </div>
                            </Link>
                        )}

                        {/* Location Selector - Only show if showLocationSelector is true */}
                        {showLocationSelector && (
                            <div className="img-contentname" onClick={() => setCountrypopup(true)}>
                                <img src={getFlagIcon(selectedState || emirate)} alt="flag" className="flagicon" />
                                <p>{selectedState?.name || emirate?.name || "Abu Dhabi"}</p>
                            </div>
                        )}

                        {/* Uncomment these sections when you need them */}
                        {/* 
                        <div className="img-contentname">
                            <img src={blogs} alt="blogs" />
                            <p>Blogs</p>
                        </div>
                        <div className="img-contentname">
                            <img src={save} alt="save" />
                            <p>Saved</p>
                        </div>
                        <div className="img-contentname">
                            <img src={profileicon} alt="profileicon" />
                            <p>Profile</p>
                        </div>
                        <div className="img-contentname">
                            <img src={plusicon} alt="plusicon" />
                            <p>Post</p>
                        </div>
                        <div className="img-contentname">
                            <img src={menu} alt="menu" />
                            <p>Menu</p>
                        </div>
                        */}
                    </div>
                )}

                {/* Only show divider if there's content below search box */}
                {hasContentBelowSearch && (
                    <div className="divider-line"></div>
                )}

                {/* Hide bottom links when search is focused or dropdown is shown */}
                {!(isSearchFocused || showDropdown) && (
                    <div className="left-bottom-links">

                        <div className="download-app">
                            <div className="hayaticon">
                                <img src={hayatlogo} alt="Hayat In Logo" />
                                {/* <a href="#close" className="close-btn">
                            <img src={xmark} alt="xmark" className="xmark" />
                        </a> */}
                            </div>
                            <h4>Download Hayat In App</h4>

                            <div className="store-buttons">
                                <div className="app_qr">
                                    <a
                                        href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={app_store} alt="App Store" />
                                    </a>

                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={play_store} alt="Google Play" />
                                    </a>
                                </div>


                                <div className="app_qr">
                                    <img className="qr" src={qr} alt="QR code" />
                                </div>
                            </div>
                        </div>
                        <div className="divider-line"></div>
                        <div className="left-bottom1">
                            <a href="/about">About</a>
                            {/* <a href="#BusinessPro">Business Pro</a> */}
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                            <a href="/downloadpage">Download</a>
                        </div>

                        {/* Uncomment these sections when you need them */}
                        {/* 
                        <div className="left-bottom1">
                            <a href="#help-center">Help Center</a>
                            <a href="#FAQ">FAQ</a>
                            <a href="#Careers">Careers</a>
                        </div>
                        <div className="left-bottom1">
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                            <div className="content-arrow">
                                <a href="#Languages">Language</a>
                                <img src={downarrow} alt="downarrow" />
                            </div>
                        </div>
                        */}
                    </div>
                )}


            </aside>

            {/* Country popup - Only render if showLocationSelector is true */}
            {showLocationSelector && countrypopup && (
                <>
                    <div
                        className="custom-overlay"
                        onClick={() => setCountrypopup(false)}
                    ></div>

                    <div className="custom-popup">
                        <div className="custom-popup-header">
                            <h4>Choose Your Location</h4>
                            <img
                                src={xmark}
                                alt="close"
                                className="close-popup"
                                onClick={() => setCountrypopup(false)}
                            />
                        </div>

                        <div className="custom-popup-body">
                            <div className="state-grid">
                                {(() => {
                                    // Filter and sort states: Abu Dhabi, Dubai, Toronto, then others
                                    const filteredStates = states.filter((state) => Number(state.country_id));

                                    // Sort states: Abu Dhabi (1), Dubai (2), Toronto (9), then others
                                    const sortedStates = [...filteredStates].sort((a, b) => {
                                        // Abu Dhabi first
                                        if (a.id === 1) return -1;
                                        if (b.id === 1) return 1;
                                        // Dubai second
                                        if (a.id === 2) return -1;
                                        if (b.id === 2) return 1;
                                        // Toronto third (right after Dubai)
                                        if (a.id === 9) return -1;
                                        if (b.id === 9) return 1;
                                        // Rest maintain original order
                                        return a.id - b.id;
                                    });

                                    return sortedStates.map((state, index, arr) => {
                                        // Disable last 4 items, but exclude Toronto from being disabled
                                        const isToronto = state.id === 9;
                                        const isDisabled = !isToronto && index >= arr.length - 4;

                                        // Determine flag icon: Abu Dhabi, Dubai use flagicon
                                        // Others use countryicons array (Oman, Qatar, Kuwait, KSA)
                                        // Toronto doesn't get any flag icon
                                        let flagSrc = flagicon;
                                        if (state.id === 9) flagSrc = countryicons[0]; //Canada
                                        else if (state.id === 5) flagSrc = countryicons[1]; // Oman
                                        else if (state.id === 6) flagSrc = countryicons[2]; // Qatar
                                        else if (state.id === 7) flagSrc = countryicons[3]; // Kuwait
                                        else if (state.id === 8) flagSrc = countryicons[4]; // KSA

                                        return (
                                            <div
                                                key={state.id}
                                                className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                onClick={() => !isDisabled && handleStateClick(state)}
                                            >

                                                <img
                                                    src={flagSrc}
                                                    alt="flag"
                                                    className="flagicon-popup"
                                                />

                                                <p>{state.name}</p>
                                            </div>
                                        );
                                    });
                                })()}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default LeftSection;